import React, { CSSProperties, FC } from 'react';
import styles from './XClose.module.css';

export interface XCloseSvgProps {
  s?: CSSProperties;
}

const XClose: FC<XCloseSvgProps> = ({ s }) => (
  <svg
    className={styles.container}
    style={{ fill: s?.color, ...s }}
    viewBox="0 0 10 10"
    role="presentation"
  >
    <path d="M9 1.8L8.2 1 5 4.2 1.8 1l-.8.8L4.2 5 1 8.2l.8.8L5 5.8 8.2 9l.8-.8L5.8 5" />
  </svg>
);

export default XClose;
